import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CashLoan } from '../Module/CashLoan.model';
import { CashLoanService } from '../service/CashLoan.service';

import { Client } from '../Module/Client.model';
import { NotificationService } from '../service/notification.service';
import { ClientService } from '../service/client.service';

@Component({
  selector: 'app-add-cash-loan',
  templateUrl: './add-cash-loan.component.html',
  styleUrls: ['./add-cash-loan.component.css']
})
export class AddCashLoanComponent implements OnInit {
  loan: CashLoan = new CashLoan();
  clientId!: number;
  client!: Client;
  loanId?: number;

  constructor(
    private loanService: CashLoanService,
    private route: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private clientService: ClientService,
    private notificationService: NotificationService

  ) {}



ngOnInit(): void {
  this.renderer.addClass(document.body, 'your-component-bg');

  this.route.queryParams.subscribe(params => {
    this.loanId = Number(params['id']);
    const clientId = Number(params['clientId']);

    if (!isNaN(clientId)) {
      this.clientService.getClientById(clientId).subscribe({
        next: (client) => {
          this.client = client;
          if (!this.loanId) {
            this.loan.client = client;
          }
        },
        error: (err) => {
          console.error('Erreur lors du chargement du client', err);
          this.notificationService.show("Erreur lors du chargement du client.");
        }
      });
    }

    if (this.loanId) {
      this.loanService.getLoanById(this.loanId).subscribe({
        next: (loan) => {
          this.loan = loan;
          if (loan.client) {
            this.client = loan.client;
          }
        },
        error: (err) => {
          console.error(err);
          this.notificationService.show("Erreur lors du chargement du prêt.");
        }
      });
    }
  });
}



submitLoan(): void {
  const loanToSend = { ...this.loan, client: { id: this.client.id } };

  if (this.loanId) {
    this.loanService.updateLoan(this.loanId, loanToSend).subscribe({
      next: () => {
        this.notificationService.show('Prêt mis à jour avec succès !');
        this.router.navigate(['/loanList']);
      },
      error: err => {
        console.error(err);
        this.notificationService.show('Échec de la mise à jour du prêt.');
      }
    });
  } else {
    this.loanService.addLoan(loanToSend).subscribe({
      next: () => {
        this.notificationService.show('Prêt enregistré avec succès !');
        this.router.navigate(['/loanList']);
      },
      error: err => {
        console.error(err);
        this.notificationService.show('Échec de l\'enregistrement du prêt.');
      }
    });
  }
}



}
